import { NotificationModel, IconsEnum} from "@systempiloten/react-lib";
import i18n from "i18next";

export const ErrorNotificationTemplate: NotificationModel = {
    icon: IconsEnum.WARNING,
    headlineText: i18n.t("errors.notificationTemplate.error"),
    iconColor: "text-sh-status-error",
    background: "bg-sh-status-error",
    strokeColor: "border-sh-status-error",
    duration: 3 * 1000,
}

export const InfoNotificationTemplate: NotificationModel = {
    icon: IconsEnum.INFO,
    headlineText: i18n.t("errors.notificationTemplate.info"),
    iconColor: "text-sh-status-info",
    background: "bg-sh-status-info",
    strokeColor: "border-sh-status-info",
    duration: 3 * 1000
}

export const SuccessNotificationTemplate: NotificationModel = {
    icon: IconsEnum.SELECTED,
    headlineText: i18n.t("errors.notificationTemplate.success"),
    iconColor: "text-sh-status-success",
    background: "bg-sh-status-success",
    strokeColor: "border-sh-status-success",
    duration: 3 * 1000
}

export const WarningNotificationTemplate: NotificationModel = {
    icon: IconsEnum.WARNING,
    headlineText: i18n.t("errors.notificationTemplate.warning"),
    iconColor: "text-sh-brand-yellow",
    background: "bg-sh-brand-yellow",
    strokeColor: "border-sh-brand-yellow",
    duration: 3 * 1000
};
